/* Collection UI only. Native Shopify GET filters; no catalog/cart writes. */
(() => {
  'use strict';
  const fold = s => s.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().trim();
  const filterURL = (href, entries) => {
    const url = new URL(href);
    for (const key of [...url.searchParams.keys()]) if (key.startsWith('filter.') || key === 'page') url.searchParams.delete(key);
    for (const [key,value] of entries) if ((key.startsWith('filter.') || key === 'sort_by') && value !== '') {
      if (key === 'sort_by') url.searchParams.set(key,value); else url.searchParams.append(key,value);
    }
    return url;
  };
  window.IUCollectionUI = {filterURL};
  function init() {
    const page = document.querySelector('[data-iu-collection-page]');
    if (!page || page.dataset.ready) return;
    page.dataset.ready = 'true';
    const current = new URL(location.href);
    if (!current.searchParams.has('sort_by') && page.dataset.defaultSort !== page.dataset.currentSort) {
      current.searchParams.set('sort_by',page.dataset.defaultSort); location.replace(current.href); return;
    }
    page.classList.add('iu-c-ready');
    const reviewRoot=document.querySelector('.jdgm-all-reviews-text');
    function compactReviews(){
      const text=reviewRoot?.querySelector('.jdgm-all-reviews-text__text');
      const link=text?.querySelector('a'), count=text?.dataset.numberOfReviews;
      if(link&&count&&link.textContent!==count+' recenzii')link.textContent=count+' recenzii';
    }
    if(reviewRoot){new MutationObserver(compactReviews).observe(reviewRoot,{childList:true,subtree:true});compactReviews();}
    const mobile = () => matchMedia('(max-width: 1024px)').matches;
    const panel = page.querySelector('.iu-c-filters');
    const form = panel.querySelector('form');
    const groups = form.querySelector('.iu-filter-groups');
    [...groups.children].filter(x=>x.matches('details')).sort((a,b)=>Number(a.dataset.order)-Number(b.dataset.order)).forEach(x=>groups.append(x));
    page.querySelectorAll('[data-iu-open],[data-iu-close]').forEach(x=>x.hidden=false);
    let opener, oldOverflow;
    function close() {
      if (!page.classList.contains('iu-c-filters-open')) return;
      page.classList.remove('iu-c-filters-open'); panel.removeAttribute('role'); panel.removeAttribute('aria-modal');
      document.body.style.overflow=oldOverflow; opener?.focus();
    }
    function open(button) {
      opener=button;
      if (mobile()) {oldOverflow=document.body.style.overflow;document.body.style.overflow='hidden';page.classList.add('iu-c-filters-open');panel.setAttribute('role','dialog');panel.setAttribute('aria-modal','true');}
      const size = button.dataset.iuOpen==='size' ? panel.querySelector('.iu-filter-group--size') : null;
      if(size){size.open=true;size.querySelector('summary').focus();size.scrollIntoView({block:'nearest'});}
      else panel.querySelector('[data-iu-close]').focus();
    }
    page.querySelectorAll('[data-iu-open]').forEach(button=>button.addEventListener('click',()=>open(button)));
    page.querySelectorAll('[data-iu-close]').forEach(button=>button.addEventListener('click',close));
    panel.addEventListener('keydown',event=>{
      if(!page.classList.contains('iu-c-filters-open'))return;
      if(event.key==='Escape'){event.preventDefault();close();}
      if(event.key==='Tab'){
        const items=[...panel.querySelectorAll('a,button,input,select,summary')].filter(x=>!x.disabled&&x.getClientRects().length);
        const first=items[0],last=items[items.length-1];
        if(event.shiftKey&&document.activeElement===first){event.preventDefault();last.focus();}
        else if(!event.shiftKey&&document.activeElement===last){event.preventDefault();first.focus();}
      }
    });
    addEventListener('resize',()=>{if(!mobile())close();});
    form.querySelectorAll('input[type="number"]').forEach(input=>{input.value=current.searchParams.get(input.name)||input.value;});
    const priceInputs=[...form.querySelectorAll('.iu-filter-prices input')];
    if(priceInputs.some(x=>x.value))priceInputs[0].closest('details').open=true;
    form.querySelectorAll('.iu-filter-group').forEach(group=>{
      const rows=[...group.querySelectorAll('[data-iu-option]')], more=group.querySelector('[data-iu-show-more]'), search=group.querySelector('[data-iu-brand-search]');
      let expanded=group.classList.contains('iu-filter-group--size');
      function display(){let found=0; const term=search?fold(search.value):'';
        rows.forEach((row,i)=>{const match=!term||fold(row.dataset.label).includes(term);if(match)found++;row.hidden=!match||(!term&&!expanded&&i>=8&&!row.querySelector('input').checked);});
        if(more){more.hidden=rows.length<=8||Boolean(term);more.textContent=expanded?'Vezi mai puține':'Vezi toate ('+rows.length+')';more.setAttribute('aria-expanded',String(expanded));}
        const empty=group.querySelector('[data-iu-brand-empty]');if(empty)empty.hidden=found!==0;
      }
      if(search){search.closest('[data-iu-brand-search-wrapper]').hidden=false;search.addEventListener('input',display);search.addEventListener('keydown',e=>{if(e.key==='Enter')e.preventDefault();});}
      more?.addEventListener('click',()=>{expanded=!expanded;display();}); display();
    });
    function submit(event){event.preventDefault();
      if(priceInputs.length===2&&priceInputs.every(x=>x.value!=='')&&Number(priceInputs[0].value)>Number(priceInputs[1].value)){
        form.querySelector('[data-iu-filter-status]').textContent='Prețul minim trebuie să fie mai mic decât prețul maxim.';priceInputs[0].focus();return;
      }
      if(form.reportValidity())location.assign(filterURL(location.href,new FormData(form)).href);
    }
    form.addEventListener('submit',submit);
    form.addEventListener('change',()=>{form.querySelector('[data-iu-filter-status]').textContent='Apasă „Vezi rezultatele” pentru a aplica selecția.';});
    page.querySelectorAll('[data-iu-facet]').forEach(link=>{
      const target=new URL(location.href);target.searchParams.delete(link.dataset.iuFacet);target.searchParams.delete('page');
      if(link.dataset.value)target.searchParams.append(link.dataset.iuFacet,link.dataset.value);link.href=target.href;
    });
    page.querySelectorAll('[data-iu-reset]').forEach(link=>{const url=new URL(location.href);for(const key of [...url.searchParams.keys()])if(key.startsWith('filter.')||key==='page')url.searchParams.delete(key);link.href=url.href;});
    const sortForm=page.querySelector('[data-iu-sort-form]');
    const sort=()=>{const url=new URL(location.href);url.searchParams.set('sort_by',sortForm.querySelector('select').value);url.searchParams.delete('page');location.assign(url.href);};
    sortForm.addEventListener('submit',e=>{e.preventDefault();sort();});sortForm.querySelector('select').addEventListener('change',sort);
    const count=[...current.searchParams.keys()].filter(k=>k.startsWith('filter.')).length;page.querySelector('[data-iu-filter-count]').textContent=count?'('+count+')':'';
    // Native browser history keeps list position when returning from a product.
    // Keep extension-provided material facts after price so price aligns across cards.
    function alignMaterial(){page.querySelectorAll('.product-item').forEach(card=>{const material=card.querySelector('.iu-curation-material-row'),price=card.querySelector('.card-price');if(material&&price&&material.previousElementSibling!==price)price.after(material);});}
    let queued=false;new MutationObserver(()=>{if(queued)return;queued=true;requestAnimationFrame(()=>{queued=false;alignMaterial();});}).observe(page.querySelector('.iu-c-results'),{childList:true,subtree:true});alignMaterial();
  }
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',init);else init();
})();
